export default {
  namespaced: true,
  vxg_master_account: {
    title: "conta mestre",
    name: "Nome",
    description: "Descrição",
    api_server: "Servidor api",
    api_user: "Usuário API",
    api_password: "Senha API",
    api_key: "Chave api",
    server_video: "Servidor de vídeo",
    export_service_url: "URL do serviço de exportação",
    source_url: "Url resource",
    number_cameras: "Número de câmeras",
    url: "Url api server",
  },
};
